
require([
	'jquery'
], function(
	$
	) {

	'use strict';

	function validateEmail(email) {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}


	// $(document).on('click', '.js_send-nl', function(){
	// 	if(!$('html').hasClass('nlDataSubmitting') && !$('html').hasClass('nlDataSubmitted')){
	// 		var email = $('.section-nlBox .nl-email').val();
	// 		var fname = $('.section-nlBox .nl-fname').val();
	// 		var lname = $('.section-nlBox .nl-lname').val();
	// 		if(email!='' && fname != '' && lname != '' && $('#dsgvo1').is(":checked")){
	// 			if (validateEmail(email)) {
	// 				var lang = $('.nl-lang').val();
	// 				var thnksmsg = $('.section-nlBox').attr('data-ok');
	// 				var errorMsg = $('.section-nlBox').attr('data-error');
	// 				$('html').addClass('nlDataSubmitting');
	// 				$.ajax({
	// 					type: 'POST',
	// 					data: {
	// 						lang: lang,
	// 						email: email,
	// 						fname: fname,
	// 						lname: lname,
	// 						action: 'mailchimp'
	// 					},
	// 				})
	// 				.done(function(data) {
	// 					$('html').addClass('nlDataSubmitted');
	// 					$('html').removeClass('nlDataSubmitting');
	// 					if (data == 200) {
	// 						$('.messageContainer').html(thnksmsg);
	// 					} else {
	// 						$('.messageContainer').html(errorMsg);
	// 					}
	// 				})
	// 				.fail(function() {
	// 					$('.messageContainer').html(errorMsg);
	// 				})
	// 				.always(function() {
	// 				});
	// 			} else {
	// 				console.log('not valid email');
	// 			}
	// 		} else {
	// 			console.log('email empty');
	// 		}
	// 	}
	// });

});
define("root/Assets/Templates/Html/NewsletterBox/Js/NewsletterBox", function(){});

